import { fetchAuthSession } from 'aws-amplify/auth';

export const checkTokenExpiration = async () => {
  try {
    const session = await fetchAuthSession();
    if (session?.tokens?.accessToken) {
      const exp = session.tokens.accessToken.payload.exp;
      const now = Math.floor(Date.now() / 1000);
      const timeLeft = exp - now;
      const minutesLeft = Math.floor(timeLeft / 60);
      
      console.log('Access token expires in:', minutesLeft, 'minutes');
      return minutesLeft;
    }
    return 0;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return 0;
  }
}; 